/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Palette_ActionsInputs */

const en_palette_actions = /** @type {(inputs: Palette_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On this page`)
};

/**
* | output |
* | --- |
* | "On this page" |
*
* @param {Palette_ActionsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const palette_actions = /** @type {((inputs?: Palette_ActionsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Palette_ActionsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_palette_actions(inputs)
});